<template src="./index.html"></template>

<script>
import { mapState } from 'vuex';
// 鼠标位置和div的左上角位置 差值
var dx, dy;
var screenWidth = window.screen.width;
var screenHeight = window.screen.height;


export default {
    name: 'ManualHelp',
    data() {
        return {
            popupShow: false,
            defferScroll: function (event) {
                event.preventDefault()
            },
            
            
            flags: false,
            position: { x: 0, y: 0 },
            nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
        }
    },
    computed:{
        ...mapState({
            xPumValue: (state)=>{
                return state.MessageSwitch.xPumValue
            },
            yPumValue: (state)=>{
                return state.MessageSwitch.yPumValue
            },
        })
    },
    mounted() {
        if(this.xPumValue!=='0' || this.yPumValue!=='0') {
            moveDiv.style.left = this.xPumValue;
            moveDiv.style.top = this.yPumValue;
        }
    },
    methods: {
        clickBtn() {
            this.popupShow = true
            
            document.body.addEventListener("touchmove", this.defferScroll, {passive: false});
            document.body.addEventListener("wheel", this.defferScroll, {passive: false});

            let data = {
                page_from:'main_page',
                page_name:'MessageSwitch',
                btn_name: 'ManualHelpBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
            };
            this.$store.dispatch('Public/inH5Record', data)
        },
        closeBtn() {
            this.popupShow = false

            document.body.removeEventListener("touchmove", this.defferScroll, {passive: false});
            document.body.removeEventListener("wheel", this.defferScroll, {passive: false});
        },
        



        // 实现移动端拖拽
        down(event){
            this.flags = true;
            var touch;
            if(event.touches){
                touch = event.touches[0];
            }else {
                touch = event;
            }
            this.position.x = touch.clientX;
            this.position.y = touch.clientY;
            
            this.dx = moveDiv.offsetLeft;
            this.dy = moveDiv.offsetTop;
        },
        move(event){
            if(this.flags){
                var touch ;
                if(event.touches){
                    touch = event.touches[0];
                }else {
                    touch = event;
                }
                this.nx = touch.clientX - this.position.x;
                this.ny = touch.clientY - this.position.y;
                this.xPum = this.dx+this.nx;
                this.yPum = this.dy+this.ny;
                let pageWidth = document.documentElement.clientWidth - moveDiv.clientWidth
                let pageHeight = document.documentElement.clientHeight - manualImg.clientHeight
                if(this.xPum < 0) {
                    this.xPum = 0
                }
                if(this.xPum > pageWidth) {
                    this.xPum = pageWidth
                }

                if(this.yPum < 0) {
                    this.yPum = 0
                }
                if(this.yPum > pageHeight) {
                    this.yPum = pageHeight
                }
                moveDiv.style.left = this.xPum+"px";
                moveDiv.style.top = this.yPum +"px";
                this.$store.commit('MessageSwitch/SET_DATA',{key:'xPumValue',data:this.xPum+"px"})
                this.$store.commit('MessageSwitch/SET_DATA',{key:'yPumValue',data:this.yPum +"px"})
                
                document.body.addEventListener("touchmove", this.defferScroll, {passive: false});
                document.body.addEventListener("wheel", this.defferScroll, {passive: false});
            }
        },
        //鼠标释放时候的函数
        end(){
            this.flags = false;
            document.body.removeEventListener("touchmove", this.defferScroll, {passive: false});
            document.body.removeEventListener("wheel", this.defferScroll, {passive: false});
        },    
    }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>